import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export default function SelectField({small=false,label,type='text',options=[],value,name,placeholder,onChange,disabled,error,errorMessage,translateError=false,isRequird=false,onkeydown, autoComplete='off',role,infoIcon=false, handleClickInfoIcon}){

    const [showPassword, setShowPassword] = useState(false);
    const [dropDownOpen, setDropDownOpen] = useState(false);
    const {t,i18n} = useTranslation();

    const ignoredElementRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if(ignoredElementRef.current && ignoredElementRef.current === event.target) {
                setDropDownOpen(prev => !prev)
            } else if (ignoredElementRef.current && !ignoredElementRef.current.contains(event.target)) {
                setDropDownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, []);

      const handleClickOption = (option) => {
        setDropDownOpen(false);
        onChange({target:{value:option.value}});
      }

    return (
        <div className={`${small ? 'w-[100px]' : 'w-[100%] min-h-[40px] mb-[10px]'} relative`} style={disabled ? {opacity: 0.5, pointerEvents: 'none'} : {}}>
            { label && !small && <label htmlFor={label} className="text-grey-900 text-[14px] font-[600] leading-[21px] mb-[3px] block">{label}{isRequird && <span className="text-danger">*</span>}</label> } 
            { infoIcon && <span className="cursor-pointer w-[24px] h-[24px] block !bg-center !bg-no-repeat absolute top-[-5px] end-0" style={{background:"url('/assets/images/info-icon.svg')"}} onClick={()=>handleClickInfoIcon()}></span>}
            <div
                ref={ignoredElementRef}
                value={value}
                style={{background:small ? '' : `url('/assets/images/select-arrow.svg')`}}
                className={`relative cursor-pointer select-none appearance-none !bg-no-repeat text-grey-600 ltr:!bg-[calc(100%-15px)_50%] rtl:!bg-[15px_50%] transition-[border] border-grey-300 ease-in-out duration-300 focus:border-lightBlue outline-none px-[12px] ${small ? 'h-[30px]' : 'h-[48px]'} text-[16px] w-[100%] ${small ? 'rounded-[4px]' : 'bg-white rounded-[8px]'} border justify-start items-center inline-flex leading-[48px] ${ error ? '!border-danger' : '' } ${ disabled ? '!bg-disabled !border-disabled' : '' }`}
                >
                <div className={`selected-option select-none absolute bottom-0 pointer-events-none ${small ? 'leading-[30px]' : ''} ${value ? '' : 'opacity-50'}`}>{value? options?.find(o=> o.value === value)?.label : placeholder}</div>
                <div className={`DropList z-[10] absolute top-[100%] select-none start-0 w-full ${small ? '' : 'h-[150px]'} bg-white border border-grey-300 ${small ? 'rounded-[4px]' : 'rounded-[10px]'} overflow-x-hidden overflow-y-auto ${dropDownOpen ? 'block' : 'hidden'} ${disabled ? '!bg-disabled !border-disabled' : ''}`}>
                {placeholder && <div value="" defaultValue={!value} disabled={value} className="opacity-50 px-[12px]">{placeholder}</div>}
                {Array.isArray(options) && options?.length > 0 && options?.map((option,index)=>{
                    return(<div key={option.label+'-'+option.value+'-'+index} className={`px-[12px] leading-[48px] select-none cursor-pointer hover:bg-darkBlue hover:text-white ${option?.disabled ? 'pointer-events-none opacity-50' : ''}`} onClick={()=>handleClickOption(option)}>{option.label}</div>)  
                })}
                </div>
            </div>
            {small && <img src="/assets/images/down-select-icon.svg" alt="" class="absolute w-[16px] h-[16px] end-[5px] top-[7px]" />}
            {errorMessage && <p className="text-danger text-[14px] font-[400] leading-[20px] pe-[5px] pt-[3px] mb-[0] block"><img src="/assets/images/error.svg" alt="" className="inline w-[16px] h-[16px] align-middle me-[3px]" />{translateError ? t(errorMessage) : errorMessage}</p>}
        </div>
    )
}